import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'isIncluded',
    standalone: true,
})
export class IsIncludedPipe implements PipeTransform {
    transform(
        list: string[] | null | undefined | string,
        item: string
    ): boolean {
        return (
            (Array.isArray(list) || typeof list === 'string') &&
            list.includes(item)
        );
    }
}
